import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import { SubjectDTO, CreateSubjectDTO, UpdateSubjectDTO, DomainInfoDTO } from '../dtos';

// Subject Management API (Subjects within an institute/domain)
export const subjectApi = {
  // Get subjects by domain (subjects for an institute)
  async getSubjectsByDomain(domainId: string): Promise<ApiResponse<SubjectDTO[]>> {
    return apiClient.get<SubjectDTO[]>(`/domains/${domainId}/subjects`);
  },

  // Get subject by ID
  async getSubjectById(subjectId: string): Promise<ApiResponse<SubjectDTO>> {
    return apiClient.get<SubjectDTO>(`/subjects/${subjectId}`);
  },

  // Create new subject
  async createSubject(data: CreateSubjectDTO): Promise<ApiResponse<SubjectDTO>> {
    return apiClient.post<SubjectDTO>('/subjects', data);
  },

  // Update existing subject
  async updateSubject(subjectId: string, data: UpdateSubjectDTO): Promise<ApiResponse<SubjectDTO>> {
    return apiClient.put<SubjectDTO>(`/subjects/${subjectId}`, data);
  },

  // Delete subject
  async deleteSubject(subjectId: string): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/subjects/${subjectId}`);
  },
};

// Domain Info API
export const domainInfoApi = {
  // Get domain information (institute details)
  async getDomainInfo(domainId: string): Promise<ApiResponse<DomainInfoDTO>> {
    return apiClient.get<DomainInfoDTO>(`/domains/${domainId}`);
  },
};

// Institute Admin Management API - Only keeping the removal functionality
export const instituteAdminManagementApi = {
  // Remove institute admin role (but keep user)
  async removeInstituteAdminRole(
    _userId: string,
    _tenantId: string,
    _domainId: string,
    userRoleId: string
  ): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/user-roles/${userRoleId}`);
  },
};

// Export all APIs
export const domainApi = {
  subject: subjectApi,
  domainInfo: domainInfoApi,
  instituteAdminManagement: instituteAdminManagementApi,
};
